export default __webpack_public_path__ + "static/educaArte-3d83110ead49bdd346075a291cbd9fce.jpeg";